import BootBanner from "./outputs/BootBanner";

function Prompt({ user, host, cwd }) {
  return (
    <span className="whitespace-nowrap">
      <span className="text-emerald-400">{user}@{host}</span>
      <span className="text-neutral-500"> {cwd} </span>
      <span className="text-sky-400">%</span>
    </span>
  );
}

export default function TerminalBody({
  lines,
  cwd,
  user,
  host,
  booted,
  input,
  setInput,
  handleKeyDown,
  scrollRef,
  inputRef,
  heightClass,
}) {
  return (
    <div
      ref={scrollRef}
      className={`bg-[#161616]/95 backdrop-blur px-4 py-4 overflow-y-auto font-mono text-[13px] sm:text-[14px] leading-[1.55] ${heightClass}`}
    >
      {lines.map((line) => {
        if (line.type === "boot-line") {
          return (
            <div key={line.id} className="text-neutral-500">
              {line.text}
            </div>
          );
        }
        if (line.type === "banner") {
          return (
            <div key={line.id} className="mb-3">
              <BootBanner />
            </div>
          );
        }
        return (
          <div key={line.id} className="mb-3">
            <div className="flex gap-2">
              <Prompt user={user} host={host} cwd={line.cwdAtRun} />
              <span className="text-neutral-100">{line.cmdText}</span>
            </div>
            {line.output && <div className="mt-1">{line.output}</div>}
          </div>
        );
      })}

      {booted && (
        <div className="flex gap-2 items-center">
          <Prompt user={user} host={host} cwd={cwd} />
          <input
            ref={inputRef}
            autoFocus
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            className="flex-1 bg-transparent outline-none border-none text-neutral-100 caret-emerald-400"
            spellCheck={false}
            autoComplete="off"
          />
        </div>
      )}
    </div>
  );
}